import React, { useState } from 'react';
import { useDebounceFn } from 'ahooks';
import { Form, message, Checkbox, Button } from 'antd';
import { formatPhone, API, setUserAccountToken, ACTIVITY_CENTER_FROM_LOGIN_FLAG } from '@yaotai/common-utils';
import { CountryPhoneField } from '../CountryPhoneField/index.js';
import { PhoneLoginVerificationCodeInput } from '../PhoneLoginVerificationCodeInput/index.js';
import { PhoneLayout } from './styles.js';
import { PHONE_LOGIN_LOCALE, phoneLoginValidateVerificationCode } from './helper.js';

const loginByPhone = async ({ info, cookieDomain, postMobileLoginApi, }) => {
    try {
        const result = await postMobileLoginApi({
            ...info,
        });
        if (!result?.data) {
            return Promise.reject();
        }
        else {
            const { RBAC_USER, RBAC_TOKEN } = result?.data || {};
            setUserAccountToken({ RBAC_USER: RBAC_USER, RBAC_TOKEN, cookieDomain });
            localStorage.setItem(ACTIVITY_CENTER_FROM_LOGIN_FLAG, 'true');
            return Promise.resolve();
        }
    }
    catch (error) {
        return Promise.reject();
    }
};
const PhoneLogin = ({ countdownTime = 90, className, serverCode, cookieDomain, codeClassName, invokeType = 'page', lang = 'zh', monorepoType, mediaType, loginSuccessJumpUrl = window.location.href, getLoginMsgCodeApi = API.rbac.getLoginMsgCode, postMobileLoginApi = API.rbac.postMobileLogin, aid, sid, extraLoginSuccessCb, }) => {
    const [form] = Form.useForm();
    const [curCodePhone, setCurCodePhone] = useState('');
    const validatePhone = async () => {
        await form.validateFields(['phone']);
        const { phone, code: verificationCodeValue } = form.getFieldsValue();
        /*
         * 用于用户再未获取验证码时已输入验证码，此时会提示“请先获取验证码”
         * 然后用户点击获取验证码，对验证码输入框进行校验
         */
        if (verificationCodeValue !== undefined) {
            form.validateFields(['code']);
        }
        const codePhone = formatPhone(phone?.code, phone?.phone);
        setCurCodePhone(codePhone);
        return { codePhone, phoneInfo: phone };
    };
    const { run } = useDebounceFn(() => {
        handleLogin();
    }, {
        leading: true,
        trailing: false,
        wait: 300,
    });
    // eslint-disable-next-line react-func/max-lines-per-function
    const handleLogin = () => {
        form.validateFields().then(async (values) => {
            const { phone: phoneInfo, code: verificationCodeValue } = values;
            const info = {
                phone: phoneInfo?.phone,
                region: phoneInfo?.code,
                scope: serverCode,
                msgcode: verificationCodeValue,
            };
            try {
                await loginByPhone({ info, cookieDomain, postMobileLoginApi });
                await extraLoginSuccessCb?.();
                window.location.replace(loginSuccessJumpUrl);
            }
            catch (error) {
                message.error(PHONE_LOGIN_LOCALE[lang]['errorCodeText']);
            }
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PhoneLayout, { className: className },
            React.createElement(Form, { form: form, style: { width: '100%' } },
                React.createElement(CountryPhoneField, { hasLabel: false, required: true, className: `${monorepoType}-${mediaType}`, validateTrigger: ['onChange'], placeholder: PHONE_LOGIN_LOCALE[lang]['mobilePlaceholder'], language: lang }),
                React.createElement(Form.Item, { noStyle: true, dependencies: ['phone'] }, ({ getFieldValue }) => (React.createElement(Form.Item, { name: "code", validateFirst: true, rules: [
                        {
                            validator: phoneLoginValidateVerificationCode({
                                codePhone: curCodePhone,
                                fromLogin: true,
                                phone: formatPhone(getFieldValue('phone').code, getFieldValue('phone').phone),
                                emptyText: PHONE_LOGIN_LOCALE[lang]['verificationCodePlaceholder'],
                                notGotCodeText: PHONE_LOGIN_LOCALE[lang]['getCodeFirstText'],
                                errorCodeText: PHONE_LOGIN_LOCALE[lang]['errorCodeText'],
                                lang,
                            }),
                        },
                    ] },
                    React.createElement(PhoneLoginVerificationCodeInput, { countdownTime: countdownTime, aid: aid, lang: lang, sid: sid, className: codeClassName, validate: validatePhone, serverCode: serverCode, getLoginMsgCodeApi: getLoginMsgCodeApi })))),
                React.createElement(Form.Item, { name: "agreed", style: { marginBottom: '8px' }, valuePropName: "checked", rules: [
                        {
                            validator: (_, value) => {
                                if (value)
                                    return Promise.resolve();
                                else
                                    return Promise.reject(PHONE_LOGIN_LOCALE[lang]['needAgreeText']);
                            },
                        },
                    ] },
                    React.createElement("div", null,
                        React.createElement(Checkbox, null),
                        React.createElement("span", { className: "ml-sm policy-text" },
                            PHONE_LOGIN_LOCALE[lang]['policyAgree'],
                            ' ',
                            React.createElement("a", { href: "//reg.163.com/agreement_mobile_ysbh.shtml", target: "_blank", rel: "noreferrer" }, PHONE_LOGIN_LOCALE[lang]['neteasePolicy']),
                            ' ',
                            PHONE_LOGIN_LOCALE[lang]['andText'],
                            ' ',
                            React.createElement("a", { href: "//reg.163.com/agreement_mobile.shtml", target: "_blank", rel: "noreferrer" }, PHONE_LOGIN_LOCALE[lang]['userPolicy'])))),
                React.createElement(Form.Item, { style: { marginBottom: 0 } },
                    React.createElement(Button, { type: "primary", className: "login-btn", onClick: run }, PHONE_LOGIN_LOCALE[lang]['Login']))))));
};

export { PhoneLogin };
